import EventHandler from "@/utils/event-handler";
const eventHandler = new EventHandler();
export default defineNuxtPlugin(() => {
  
  return {
    provide: {
      partenairesEvents: eventHandler
    }
  }
});
